import { TVariantColorValue } from './types';
import { theme } from '../../../theme';

const { colors } = theme;

export enum FnAlertTypes {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error'
}

export const VARIANT_COLORS: Record<FnAlertTypes, TVariantColorValue> = Object.freeze({
  [FnAlertTypes.Info]: {
    color: colors.textPrimary,
    backgroundColor: colors.surfaceBase
  },
  [FnAlertTypes.Error]: {
    color: colors.error,
    backgroundColor: colors.errorBackground
  },
  // Warning and Success variants are not used in app yet and not styled
  [FnAlertTypes.Warning]: {
    color: colors.textPrimary,
    backgroundColor: colors.white
  },
  [FnAlertTypes.Success]: {
    color: colors.textPrimary,
    backgroundColor: colors.white
  }
});
